<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper navbar-full p-0">
      <vs-navbar
        class="navbar-custom navbar-skelton custom-navbar-header text-white"
        :class="navbarClasses"
        :style="navbarStyle"
        :color="navbarColor"
      >
        <div class="flex flex-row items-center flex-shrink-0">
          <router-link
            tag="div"
            to="/"
            class="vx-logo cursor-pointer flex items-start"
          >
            <img
              height="35"
              src="@/assets/images/logo/lotus-logo.svg"
              alt="lotus-logo"
            />
          </router-link>
          <h-nav-menu
            class="custom-navbar-menu"
            :navMenuItems="theNavMenuItems"
            :navbarColor="navbarColor"
          />
        </div>

        <div class="flex flex-row">
          <!-- <search-bar class="mr-4" /> -->
          <!-- <notification-drop-down /> -->
          <profile-drop-down />
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import ProfileDropDown from './components/ProfileDropDown.vue'
import navMenuItems from '../vertical-nav-menu/navMenuItems.js'
import HNavMenu from '../horizontal-nav-menu/HorizontalNavMenu.vue'

export default {
  name: 'the-navbar-horizontal',
  props: {
    logo: { type: String },
    navbarType: {
      type: String,
      required: true
    }
  },
  components: {
    HNavMenu,
    ProfileDropDown
  },
  data() {
    return {
      navMenuItems: JSON.parse(JSON.stringify(navMenuItems))
    }
  },
  computed: {
    navbarColor() {
      let color = '#00BCB4'
      if (this.navbarType === 'sticky') color = '#f7f7f7'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7'
        }
      }

      if (this.isThemedark) {
        if (color === '#00BCB4') {
          color = '#10163a'
        } else {
          color = '#262c49'
        }
      }

      return color
    },
    isThemedark() {
      return this.$store.state.theme === 'dark'
    },
    navbarStyle() {
      return this.navbarType === 'static'
        ? { transition: 'all .25s ease-in-out' }
        : {}
    },
    navbarClasses() {
      return this.scrollY > 5 && this.navbarType === 'static'
        ? null
        : 'd-theme-dark-light-bg shadow-none'
    },
    scrollY() {
      return this.$store.state.scrollY
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    userRole() {
      return this.$store.state.AppActiveUser.userRole.split(', ')
    },
    showProgramDashboard() {
      return (
        this.userRole.includes('VIP') ||
        this.userRole.includes('Program') ||
        this.userRole.includes('Senior') ||
        this.userRole.includes('AssetsAndEstatesAdmin')
      )
    },
    theNavMenuItems() {
      let theNavMenuItems = [...this.navMenuItems]

      if (!this.isAdmin) {
        theNavMenuItems = theNavMenuItems.filter(item => {
          return item.slug !== 'users'
        })
      }

      if (this.userRole.includes('AssetsAndEstatesAdmin')) {
        theNavMenuItems.filter(item => {
          if (item.slug === 'users') {
            const findIndex = item.submenu.findIndex(x => x.slug === 'userlog')
            item.submenu.splice(findIndex, 1)
          }
        })
      }

      return theNavMenuItems
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/components/theNavbarHorizontal.scss';
</style>
